import attachment from "./assets/images/attachment.png";
import sendIcon from "./assets/images/send_icon.png";

export function formatDate(d: string | number | Date) {
    const date = d && d.split(" ")[0].split("-");
    if (date) {
        return date[1] + "/" + date[2] + "/" + date[0];
    }
}

export function prompt(d: string | number | Date) {
    return "";
}

export const chatStyles = {
    chatWindowStyle: {
        width: "100%",
        backgroundColor: "#f5f5fe",
        boxShadow: "none",
        borderRadius: "20px",
        height: "calc(100vh - 100px)"
    },
    headerStyle: {
        backgroundColor: "#E9EAFC",
        color: "#454554",
        backgroundImage: "none",
        border: "none",
        borderTopLeftRadius: "20px",
        borderTopRightRadius: "20px"
    },
    bodyStyle: {
        backgroundColor: "#E9EAFC",
        borderBottomLeftRadius: "20px",
        borderBottomRightRadius: "20px",
        padding: "0 20px"
    },
    chatInputContainerStyle: {
        backgroundColor: "#D7D9FA",
        margin: "0px",
        border: "none",
        borderRadius: "50px",
        height: "60px",
        marginTop: "20px",
    },
    footerStyle: {
        width: "30px",
        height: "30px",
        display: "none"
    },
    botBubbleStyle: {
        backgroundColor: "#E9EAFC",
        color: "#454554",
        borderRadius: "10px",
        paddingLeft: "0px !important",
        marginLeft: "0px !important"
    },
    userBubbleStyle: {
        backgroundColor: "rgb(251, 251, 254)",
        color: "#454554",
        borderRadius: "10px",
        padding: "10px 20px",
        fontSize: "14px"
    },
    sendButtonStyle: {
        border: "1px solid #e9eafc",
        backgroundColor: "#e9eafc",
        borderRadius: "50px",
        padding: "5px",
        height: "40px",
        width: "40px"
    },
    sendButtonHoveredStyle: {
        border: "1px solid #e9eafc",
        backgroundColor: "#e9eafc",
        borderRadius: "50px",
        padding: "5px",
        height: "40px",
        width: "40px"
    },
    chatInputAreaStyle: {
        marginLeft: "40px",
        boxShadow: "none !important",
        backgroundColor: "#D7D9FA",
        boxSizing: "border-box",
        overflowY: "auto",
        color: "#1a28c1"
    },
    chatInputAreaFocusedStyle: {
        marginLeft: "40px",
        boxShadow: "none !important",
        backgroundColor: "#D7D9FA",
        boxSizing: "border-box",
        overflowY: "auto",
        color: "#1a28c1"
    },
    fileAttachmentButtonStyle: {
        border: "1px solid #e9eafc",
        backgroundColor: "#e9eafc",
        borderRadius: "50px",
        padding: "5px",
        height: "40px",
        width: "40px"
    },
    fileAttachmentButtonDisabledStyle: {
        border: "1px solid #e9eafc",
        backgroundColor: "#e9eafc",
        borderRadius: "50px",
        padding: "5px",
        height: "40px",
        width: "40px"
    },
    fileAttachmentIconStyle: {
        backgroundImage: "url(" + attachment + ")",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    },
    fileAttachmentIconDisabledStyle: {
        backgroundImage: "url(" + attachment + ")",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        pointerEvents: "none"
    },
    sendIconStyle: {
        backgroundImage: "url(" + sendIcon + ")",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    }
};
